import React ,{useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux"
import bars from '../../assets/bars-solid.svg'
import logo from '../../assets/logo.png';
import search from '../../assets/search-solid.svg'
import Avatar from '../Avatar/Avatar';
import './navbar.css';
import {setcurrentuser} from '../../action/currentuser'
import {jwtDecode} from "jwt-decode"
function Navbar({ handleslidein }) {
    var User = useSelector((state)=>state.currentuserreducer)
    const navigate = useNavigate()
    const dispatch=useDispatch();
    const handlelogout=()=>{
        dispatch({type:"LOGOUT"})
        navigate("/")
        dispatch(setcurrentuser(null))
    }

    useEffect(()=>{
        const token =User?.token;
        if(token){
            const decodedtoken=jwtDecode(token);
            if(decodedtoken.exp * 1000 < new Date().getTime()){
                // perform logout inline to avoid using handlelogout in deps
                dispatch({type:"LOGOUT"});
                navigate("/");
                dispatch(setcurrentuser(null));
            }
        }
        dispatch(setcurrentuser(JSON.parse(localStorage.getItem("Profile"))))
    },[User?.token,dispatch,navigate]);
    return (
        <nav className="main-nav">
            <div className="navbar">
                <button className="slide-in-icon" onClick={() => handleslidein()}>
                    <img src={bars} alt="bars" width='15' />
                </button>
                <div className="navbar-1">
                    <Link to='/' className='nav-item nav-logo'>
                        <img src={logo} alt="logo" />
                    </Link>
                    <Link to="/" className="nav-item nav-btn res-nav">
                        About
                    </Link>
                    <Link to="/" className="nav-item nav-btn res-nav">
                        Products
                    </Link>
                    <Link to='/teams' className='nav-item'>For Teams</Link>
                    <form><input type="text" placeholder='Search...' />
                        <img src={search} alt="search" width='18' className='search-icon' />
                    </form>
                </div>
                <div className="navbar-2">
                    {User === null ? (
                        <Link to='/Auth' className='nav-item nav-links'>
                            Log in
                        </Link>
                    ) : (
                        <>
                            <Link to={`/Users/${User?.result?._id}`} style={{ textDecoration: "none" }}>
                                <Avatar 
                                    avatar={User?.result?.avatar}
                                    backgroundColor='#009dff' 
                                    px='10px' py='7px' 
                                    borderRadius='50%' 
                                    color="white"
                                    style={{ width: 48, height: 48, border: '3px solid #009dff' }}
                                >
                                    {(!User?.result?.avatar && User?.result?.name) && (
                                        <span style={{ color: "white", textDecoration: "none" }}>
                                            {User.result.name.charAt(0).toUpperCase()}
                                        </span>
                                    )}
                                </Avatar>
                            </Link>
                            <button className="nav-tem nav-links" onClick={handlelogout}>Log out</button>
                        </>
                    )}
                </div>
            </div>
        </nav>
    )
}

export default Navbar